import {history} from 'instantsearch.js/es/lib/routers';
import Vue from '../main/vue';
import router from '../main/vue-routes';
import components from '../algolia';

const loadMaintenanceRepairGuides = () => {
  if (document.querySelector('.repair-maintenance-guides')) {
    new Vue({
      el: '.repair-maintenance-guides',
      comments: true,
      components,
      data() {
        const indexName = this.$algolia.indexPrefix + 'technical_downloads';

        const routing = {
          router: history(),
          stateMapping: {
            stateToRoute(uiState) {
              const indexUiState = uiState[indexName] || {};
              return {
                query: indexUiState.query,
                product_type: indexUiState.menu?.product_type
              };
            },
            routeToState(routeState) {
              return {
                [indexName]: {
                  query: routeState.query,
                  menu: {
                    product_type: routeState.product_type
                  }
                }
              };
            }
          }
        };

        return {
          indexName,
          routing,
          facets: ['product_type'],
          filterString: 'download_type:\'Repair & Maintenance Guide\''
        };
      },
      router
    });
  }
};

export default loadMaintenanceRepairGuides;
